import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ContainerCreate,
    ContainerDto,
    ContainerRead,
    ContainerSearchParams,
} from '../../entities/container.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ContainerMetadataMap } from './container.mapping-profile';

@Injectable()
export class ContainerMapper extends AbstractEntityMapper<
    ContainerRead,
    ContainerCreate,
    ContainerDto,
    ContainerSearchParams
> {
    constructor() {
        super(ContainerDto, PlatformWmsMapper, ContainerMetadataMap.symbols);
    }
}
